import TextSlide from './text'
export default TextSlide
